import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { SideNote } from 'src/app/model';
import { SideNoteProvider } from 'src/app/providers';
import * as moment from 'moment';

@Component({
  selector: 'app-sidenote-reminder',
  templateUrl: './sidenote-reminder.component.html',
  styleUrls: ['./sidenote-reminder.component.scss']
})

export class SidenoteReminderComponent implements OnInit {

  @ViewChild('reminderForm') reminderForm: any;
  subject: Subject<boolean>;
  note: SideNote;
  date: Date;
  time: Date = new Date();
  today: Date = new Date();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private sideNoteProvider: SideNoteProvider
  ) { }

  ngOnInit(): void {
  }

  /** Set Reminder */
  setReminder(): void {
    if(this.reminderForm.valid){
      let reminderDate = this.getAsDate(moment(this.date).format('MMM-DD-YYYY'), moment(this.time).format('HH:mm A'))

      this.bsModalRef.hide();
      this.subject.next(true);
      this.subject.complete();
    }
  }

  /** Close modal */
  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  getAsDate(day, time): any{
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM = time.match(/\s(.*)$/)[1];
    if(AMPM == "pm" && hours<12) hours = hours+12;
    if(AMPM == "am" && hours==12) hours = hours-12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if(hours<10) sHours = "0" + sHours;
    if(minutes<10) sMinutes = "0" + sMinutes;
    time = sHours + ":" + sMinutes + ":00";

    var d = new Date(day);
    var n =  moment(d).format('YYYY-MM-DD');
    var newDate = new Date(n+"T"+time);
    return newDate;
  }
}
